<template>
  <div class="work-wrap">
    <div v-for="(item, idx) in workObj" :key="`work-obj-${item.id}`" class="work-item">
      <WorkExp
        :pass-jobfunction="jobfunction"
        :pass-industry="industry"
        :pass-location="location"
        :pass-joblevel="joblevel"
        :init-data="item"
        :last-item="idx === workObj.length - 1 ? true : false"
        :check-field="getAction"
        @add="addItem"
        @remove="removeItem(idx)"
        @pass="passData(item.id, $event)"
      />
    </div>
    <div v-if="workObj !=null && workObj.length === 0" class="l-flex l-j-between">
      <button @click="addItem" class="btn remove-btn l-flex l-align-center pl-0">
        <i class="fas fa-plus-circle" />
        <span class="pl-2">{{ cpLang('profile.add_new') }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import WorkExp from '@/components/profile/edit_profile/WorkExp'

export default {
  components: {
    WorkExp
  },
  props: {
    jobfunction: {
      type: Array,
      default: null
    },
    industry: {
      type: Array,
      default: null
    },
    location: {
      type: Array,
      default: null
    },
    joblevel: {
      type: Array,
      default: null
    },
    initData: {
      default: null,
      type: Array
    },
    checkFieldAll: {
      default: false,
      type: Boolean
    },
    isLanding: {
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      workObj: [],
      blankObj: {
        jobtitletext: '',
        companyname: '',
        expfrom: { mth: 0, yr: 0, res: '' },
        expto: { mth: 0, yr: 0, res: '' },
        ismostrecent: false,
        location: 0,
        manageriallevel: '',
        subfields: '',
        industry: '',
        roles: '',
        achievement: '',
        salarytype: 0,
        actualsalary: 0,
        isNew: true
      },
      ary: [],
      getAction: false,
      count: 0,
      result: []
    }
  },
  watch: {
    initData(v, ov) {
      if (v) {
        this.init(v)
      }
    },
    checkFieldAll() {
      this.getAllChildObj()
    }
  },
  mounted() {
    if (this.isLanding && this.workObj.length === 0) {
      this.addItem()
    }
    const vm = this
    window.addEventListener('saveAll', function () { vm.save() })
  },
  methods: {
    init: function(obj) {
      if (obj) {
        this.workObj = JSON.parse(JSON.stringify(this.initData))
      }
    },
    addItem: async function() {
      const newObj = await JSON.parse(JSON.stringify(this.blankObj))
      const newObjId = Date.now()
      newObj.id = newObjId
      this.workObj.push(newObj)
    },
    removeItem: function(idx) {
      this.workObj.splice(idx, 1)
      this.ary.splice(idx, 1)
    },
    getAllChildObj: function() {
      if (this.workObj.length === 0) {
        return this.$emit('pass', 'pass')
      } else {
        this.getAction = !this.getAction
      }
    },
    passData: async function(id, obj) {
      if (this.ary.lenght === 0) {
        this.ary.push(obj)
      } else {
        const res = this.ary.findIndex(i => i.id === id)
        if (obj === 'pass') {
          this.$emit('pass', 'pass')
          return
        }
        if (res === -1) {
          this.ary.push(obj)
        } else {
          this.ary.splice(res, 1, obj)
        }
      }
      await this.count++
      if (this.count === this.ary.length) {
        this.validation()
      }
    },
    validation: function() {
      const res = this.ary.every(k => k.valid)
      if (res) {
        const experiences = []
        this.ary.forEach(function(i) {
          experiences.push(i.obj)
        })
        this.result = JSON.parse(JSON.stringify(experiences))
        this.$emit('pass', { valid: true, experiences })
      }
      this.count = 0
    },
    save: async function() {
      const params = { experiences: [] }
      params.experiences = JSON.parse(JSON.stringify(this.result))
      await this.$axios.post('/member/profile/experiences', params)
    }
  }
}
</script>

<style lang="scss">
  .work-item{
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #e6e6e6;
    &:last-child{
      border-bottom: none;
      margin-bottom: 0;
    }
  }
</style>
